module.exports = __webpack_public_path__ + "static/img/96050F_1_2_C_20230425_LC.4e92397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96050F_1_2_C_20230425_LC.png
// module id = n8WS
// module chunks = 0